import { Calendar } from '@/components/ui/calendar';
import { FieldSeparator } from '@/components/ui/field';
import type { DateRange } from 'react-day-picker';

import { CalendarFooter } from './calendar-footer';

interface CalendarSectionProps {
  dateRange: DateRange | undefined;
  onRangeChange: (range: DateRange | undefined) => void;

  handleCancel: () => void;
  handleApply: () => void;
}

export function CalendarSection({ dateRange, onRangeChange, handleCancel, handleApply }: CalendarSectionProps) {
  return (
    <div className="p-3">
      <Calendar
        mode="range"
        defaultMonth={dateRange?.from}
        selected={dateRange}
        onSelect={onRangeChange}
        numberOfMonths={1}
        disabled={(date) => date > new Date()}
      />
      <FieldSeparator className="mb-2" />
      <CalendarFooter handleCancel={handleCancel} handleApply={handleApply} />
    </div>
  );
}
